<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" stroke-width="2" />
    </svg>
</template>
